var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000031925397269372394900000013915251276890874027_"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor"
    },
    d: "M50.38,19.765h-3.231v-4.514c0-8.371-6.795-15.179-15.148-15.179S16.854,6.883,16.854,15.251v4.514 h-3.231c-4.999,0-9.051,4.061-9.051,9.069v26.17c0,5.007,4.052,9.069,9.051,9.069h36.755c4.999,0,9.051-4.061,9.051-9.069v-26.17 C59.431,23.826,55.378,19.765,50.38,19.765z M38.352,49.805c0.298,0.834-0.319,1.712-1.203,1.712h-10.29 c-0.884,0-1.501-0.878-1.203-1.712l2.337-6.542c-1.782-1.262-2.949-3.339-2.949-5.693c0-3.85,3.114-6.972,6.956-6.972 s6.956,3.121,6.956,6.972c0,2.351-1.164,4.425-2.943,5.688L38.352,49.805z M38.963,19.765H25.044v-4.514 c0-3.845,3.123-6.975,6.96-6.975s6.96,3.13,6.96,6.975V19.765z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.9e95b757.svg";
export { ForwardRef as ReactComponent };